export default __webpack_public_path__ + "a8221201a7a8c633eae1b830de800b18.svg";